export default __webpack_public_path__ + "static/media/general_conditions_mytv.d8e0b4b9.pdf";